import {womenUserHttp} from './index'

function womenUserHttpRequest(url, method, data) {
    return womenUserHttp({
        url: url,
        method: method,
        data: data
    })
}

function get(url, data) {
    return womenUserHttpRequest(url, 'get', data)
}

function post(url, data) {
    return womenUserHttpRequest(url, 'post', data)
}

export function shopItemStockBook() {
    return get('/shopping/current/stock')
}

export function searchUser(data) {
    return post('/cat/admin/search', data)
}

export function searchOrder(data) {
    return post('/shopping/admin/record', data)
}

export function getUser(data) {
    return post('/user/get/' + data)
}

export function queryCoin(data) {
    return post('/user/coin/' + data)
}

export function trans(from, to) {
    return post('/user/trans/' + from + "/" + to)
}

export function addCoin(id, coin) {
    return post('/user/coin/add/' + id + "/" + coin)
}

export function vip(nickId, vipType, vip, event, account) {
    return post('/user/vip/' + nickId + "/" + vipType + "/" + vip + "/" + event + "/" + account)
}